export function isForeignCompany(company) {
  return company && company.countryCode !== 'my';
}
